<template>
	<a
		class="site_button"
		:class="[theme, type]"
		:href="parsedLink ? parsedLink.url : null"
		:target="parsedLink ? parsedLink.target : null"
		@mouseenter="hovered = true"
		@mouseleave="hovered = false"
		ref="site_button"
	>
		<svg
			class="video_icon"
			v-if="type === 'video'"
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M1.5 10C1.5 5.3056 5.30557 1.5 10 1.5C14.6944 1.5 18.5 5.3056 18.5 10C18.5 14.6944 14.6944 18.5 10 18.5C5.30557 18.5 1.5 14.6944 1.5 10ZM10 0C4.47716 0 0 4.47717 0 10C0 15.5228 4.47716 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47717 15.5228 0 10 0ZM8.16656 6.50513L13.5752 10L8.16656 13.4949V6.50513ZM6.66656 16.25L16.339 10L6.66656 3.75V16.25Z"
				fill="black"
			/>
		</svg>

		<div
			class='site_button_title'
			v-html="button_label ? button_label : parsedLink.title"
		></div>

		<svg
			class='cta'
			width="16"
			height="11"
			viewBox="0 0 16 11"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			v-if="type != 'download'"
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M13.4019 4.52298L9.83196 0.953035L10.785 0L16 5.21501L10.785 10.43L9.83196 9.47698L13.4019 5.90703H0V4.52298H13.4019Z"
				fill="#2C584E"
			/>
		</svg>

		<svg
			xmlns="http://www.w3.org/2000/svg"
			class="external_link_icon"
			v-if="
        (parsedLink.target === '_blank' && type != 'cta') ||
        (button_link.target === '_blank'  && type != 'cta') ||
        (target === '_blank'  && type != 'cta')
      "
		>
			<g
				id="External-Link-Icon"
				transform="translate(0.75 1.061)"
			>
				<path
					id="Path_276"
					data-name="Path 276"
					d="M16.167,14.444v4.667a1.556,1.556,0,0,1-1.556,1.556H6.056A1.556,1.556,0,0,1,4.5,19.111V10.556A1.556,1.556,0,0,1,6.056,9h4.667"
					transform="translate(-4.5 -6.667)"
					fill="none"
					stroke="#232350"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.5"
				/>
				<path
					id="Path_277"
					data-name="Path 277"
					d="M22.5,4.5h4.667V9.167"
					transform="translate(-13.167 -4.5)"
					fill="none"
					stroke="#232350"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.5"
				/>
				<path
					id="Path_278"
					data-name="Path 278"
					d="M15,13.056,23.556,4.5"
					transform="translate(-9.556 -4.5)"
					fill="none"
					stroke="#232350"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.5"
				/>
			</g>
		</svg>

		<svg
			v-if="type === 'download'"
			class='download'
			width="289"
			height="278"
			viewBox="0 0 289 278"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M238.611 100.171L159.997 178.785V0H130.997V179.785L51.3831 100.171L34 117.554L144.997 228.551L255.994 117.554L238.611 100.171ZM289 250H0V278H289V250Z"
				fill="#2C584E"
			/>
		</svg>

	</a>
</template>

<script>
export default {
	data() {
		return {
			button_label: this.label,
			button_link: this.link,
			hovered: false,
		};
	},

	props: {
		link: {},
		label: {},
		target: {},
		theme: {
			default: 'light',
		},
		type: {
			default: 'normal',
		},
	},

	computed: {
		parsedLink() {
			if (typeof this.link === 'object' && this.link !== null) {
				return this.link;
			} else if (!Array.isArray(this.link)) {
				try {
					return JSON.parse(this.link);
				} catch (e) {
					return null;
				}
			} else {
				return null;
			}
		},
	},

	watch: {
		link() {
			this.button_link = this.link;
		},
	},

	methods: {
		checkEmpty(e) {
			if (this.button_link.url === '#') {
				// this.$refs.site_button.removeAttribute('href');
				e.preventDefault();
			}
		},
	},

	components: {},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.site_button {
	display: inline-flex;
	padding: 0 16px;
	border: 1px solid var(--white);
	border-radius: 0;
	background: transparent;
	text-decoration: none;
	height: 40px;
	display: inline-flex;
	justify-content: center;
	align-items: center;
	transition: 0.2s ease background;
	color: var(--white);
	width: fit-content;

	.video_icon {
		margin-right: 7px;
	}

	.external_link_icon {
		margin-left: 8px;

		line,
		path {
			stroke: var(--white);
			transition: 0.2s ease all;

			g {
				stroke: var(--white);
				transition: 0.2s ease all;
			}
		}
	}

	@media (hover) {
		&:hover {
			background: var(--dark-green);
			transition: 0.2s ease all;
			cursor: pointer;
			border: 1px solid var(--dark-green);

			svg {
				path {
					fill: var(--white);
				}
			}
		}
	}

	&:disabled {
		opacity: 0.5;
	}

	.site_button_title {
		font: normal normal normal 14px/20px var(--primary-font-family);
		transition: 0.2s ease all;
		margin-right: 0;
		position: relative;
		z-index: 10;
		text-transform: uppercase;
		letter-spacing: 0.7px;
	}

	svg {
		&.cta {
			height: 100%;
			margin-left: 10px;
		}

		&.external_link_icon {
			width: 16px;
			height: 16px;
			margin-left: 10px;
		}

		&.download {
			width: 16px;
			height: 16px;
			margin-left: 10px;
		}
	}

	img {
		display: flex;
		max-width: 24px;
		max-height: 12px;
		margin-left: 8px;
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/PrimaryButton.vue